<template>
  <div class="panel-cards-actions-wrapper">
    <ul class="list-unstyled m-0" v-if="!isEditMode">
      <li @click.stop="showEditTitlePanel">
        <i class="fa fa-pencil"></i> {{ $t('panels.edit_title') }}
      </li>

      <li
        v-show="isSegmentCard &&  paramsClient.nb_screen_segment !== 1"
        v-close-popover.all
        @click.stop="$emit('duplicated')"
        style="white-space: nowrap;"
        :class="{
          disabled: selectedSlides.length >= permission.nb_screen_segment && getNbSreenSegment,
        }"
      >
        <i class="fa fa-clone"></i> {{ $t('panels.duplicateSegment') }}
      </li>

      <li
        v-show="!isSegmentCard || paramsClient.nb_screen_segment === 1"
        v-close-popover.all
        @click.stop="$emit('duplicated')"
        style="white-space: nowrap;"
        :class="{
          disabled: selectedSlides.length >= permission.nb_screen_segment && getNbSreenSegment,
        }"
      >
        <i class="fa fa-clone"></i> {{ $t('panels.duplicateScreen') }}
      </li>

      <li
        @click.stop="addTransition(card)"
        id="li-show-modal"
        v-show="show_transition && (index > 0 || startGeneric)"
      >
        <i class="icon-transition"></i> Transition
      </li>

      <li
        v-if="showBtnDuration"
        v-has-permission="'edit_duration_segment_action'"
        @click.stop="showEditDurationPanel"
      >
        <i class="fa fa-clock-o"></i>{{ $t('panels.duration') }}
      </li>

      <li
        @click.stop="handleDelete($event)"
        class="text-danger"
        v-show="isRemovable"
        v-close-popover.all
      >
        <i class="fa fa-trash"></i> {{ $t('panels.deleteScreen') }}
      </li>
    </ul>

    <div class="edit-panel" @click.stop="" v-else>
      <div class="actions-wrapper">
        <button class="btn btn-link btn-sm cancel-btn" @click.stop="toggleEditMode(true)">
          <span class="icon-arrow-left-alt"></span>
        </button>
        <button v-close-popover.all ref="closeBtn" hidden></button>
        <button class="btn btn-link btn-sm cancel-btn" @click="closePopover">
          <span class="icon-close"></span>
        </button>
      </div>

      <div class="form-group" v-show="editMode === 'title'">
        <label>{{ $t('panels.edit_title') }}</label>
        <input
          :title="$t('panels.title')"
          :placeholder="$t('panels.title')"
          type="text"
          class="form-control form-control-sm"
          v-model="title"
          @keyup.enter.stop="handleUpdate()"
          :maxlength="getmaxLength"
        />
      </div>
      <div class="form-group" v-show="editMode === 'duration'" :class="{ 'has-error': hasError }">
        <label>{{ $t('panels.duration') }}</label>
        <input
          :title="$t('panels.duration')"
          :placeholder="$t('panels.duration')"
          type="text"
          class="form-control form-control-sm"
          v-model="durationInput"
          @keyup.enter.stop="handleUpdate()"
        />
        <small class="text-error" v-if="hasError">Valeur invalide!</small>
      </div>
      <div class="row">
        <div class="col-sm-12 text-right">
          <button class="btn btn-link btn-sm save-btn" @click.stop="handleUpdate()">
            <span class="icon-save"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import mixin from '../../mixins/Mixin.js';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import HasPermission from '../../core/directives/HasPermission.js';
import * as durationHelper from '../../helpers/duration-handler';

export default {
  name: 'CustomPanelCardActions',
  mixins: [mixin],
  directives: {
    HasPermission,
  },
  data() {
    return {
      show_transition: false,
      isEditMode: false,
      editMode: '',
      oldTitle: '',
      oldDuration: '',
      durationValue: 0,
      showError: false,
    };
  },
  props: {
    index: Number,

    isSegmentCard: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      required: true,
    },
    segment: {
      type: Object,
      default: () => ({ screens: [] }),
    },
  },
  mounted() {
    this.show_transition = this.permission.show_transition;
  },
  computed: {
    ...mapGetters({
      currentSlide: 'slides/getCurrent',
      slideIndex: 'slides/getSlideIndex',
      allSlides: 'slides/getSelected',
      getmaxLength: 'common/getmaxLength',
      selectedSlides: 'slides/getSelected',

      currentSegment: 'segments/getCurrent',
      segmentIndex: 'segments/getSegmentIndex',
      allSegments: 'segments/getSelectedSegments',
      permissions: 'getPermissions',
      hasFullscreenVideo: 'segments/hasFullscreenVideo',
      getByUid: 'segments/getByUid',

      paramsClient: 'getParamsClients',
      permission: 'getPermissions',
      startGeneric: 'segments/getStartGeneric',
    }),
    showBtnDuration() {
      if (
        (this.$route.name === 'add' || this.$route.name === 'edit') &&
        this.paramsClient.default_segment_duration !== null &&
        !this.isSegmentCard
      ) {
        return false;
      } else return true;
    },
    isSegmentMode() {
      return this.$route.name === 'segment';
    },
    isRemovable() {
      if (this.isSegmentMode) {
        return this.allSlides.length > 1;
      }
      if (this.isSegmentCard) {
        return this.allSegments.length > 1;
      }
      return this.segment.screens.filter(s => s.type !== 'startGeneric').length > 1;
    },
    title: {
      get: function() {
        if(this.paramsClient.nb_screen_segment===1)
          return this.card.screens[0].title;
        else
          return this.card.title;
      },
      set: function(value) {
        if (!this.isSegmentMode) {
          if(this.paramsClient.nb_screen_segment===1)
          this.updateFirstScreenSegmentTitle({ title: value, uid: this.card.uid });
          else
          this.updateSegmentTitle({ title: value, uid: this.card.uid });

        } else {
          this.updateSlideTitle({ title: value, uid: this.card.uid });
        }
      },
    },
    duration: {
      get: function() {
        return this.isSegmentCard ? this.card.duration : this.card.options.duration;
      },
      set: function(value) {
        this.durationValue = value;
        if (!this.isSegmentMode) {
          this.updateSegmentDuration({ duration: value, uid: this.card.uid });
        } else {
          this.updateSlideDuration({ duration: value, uid: this.card.uid });
        }
      },
    },
    durationInput: {
      get: function() {
        let value = this.duration;
        let hours = Math.floor(value / 3600);
        value %= 3600;
        let minutes = Math.floor(value / 60);
        let seconds = value % 60;
        let addZero = v => (v < 10 ? '0' + v : v);
        let t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function(value) {
        this.showError = false;
        this.duration = value
          .split(':')
          .reverse()
          .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
      },
    },
    hasError() {
      return this.showError && (!this.hasFullscreenVideo(this.card.uid) || this.isSegmentCard);
    },
  },
  methods: {
    ...mapActions('slides', [
      'updateTitle',
      'updateSlideTitle',
      'updateSlideDuration',
      'removeSlideByUid',
      'setCurrentSlide',
    ]),
    ...mapActions('segments', [
      'updateFirstScreenSegmentTitle',
      'updateSegmentTitle',
      'updateSegmentDuration',
      'removeSegmentByUid',
      'setCurrentSegment',
      'removeSlideFromSegmentByUid',
      'updateTitleScreenInSegment',
      'updateTitleSegment',
      'setCurrentSegmentTitle',
    ]),
    addTransition(segment) {
      eventHub.$emit('eventaAddTransition', Object.assign({}, segment.screens[0]));
    },
    showEditTitlePanel() {
      this.toggleEditMode();
      this.editMode = 'title';
      this.oldTitle = this.title;
    },
    showEditDurationPanel() {
      this.toggleEditMode();
      this.editMode = 'duration';
      this.oldDuration = this.duration;
      this.durationValue = this.duration;
      this.showError = false;
    },
    toggleEditMode(cancel = false) {
      this.isEditMode = !this.isEditMode;
      if (cancel) {
        if (this.editMode === 'title') {
          this.title = this.oldTitle;
        } else {
          this.duration = this.oldDuration;
        }
      }
    },
    closePopover() {
      this.toggleEditMode(true);
      this.$refs.closeBtn.click();
    },
    handleUpdate() {
      if (this.editMode === 'title') {
        if (!this.isSegmentMode) {
          if (this.isSegmentCard) {
            this.updateSegment();
          } else {
            this.updateTitleScreen();
          }
        } else {
          this.updateTitleSlide();
        }
      } else {
        if (this.$route.name === 'add' || this.$route.name === 'edit') {
          if (
            durationHelper.isMultipleBy30() &&
            Math.abs(this.durationValue - this.oldDuration) % 30 > 0
          ) {
            this.showError = true;
            if (!this.isSegmentCard && this.hasFullscreenVideo(this.card.uid)) {
              this.$root.$emit('eventExtendSegmentDuration', {
                uid: this.getByUid(this.card.uid).uid,
              });
            }
            return;
          }
          if (!this.isSegmentMode) {
            this.updateSegmentDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true,
            });
            this.showError = false;
          } else {
            this.updateSlideDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true,
            });
          }
        } else if (this.$route.name === 'segment') {
          if (!this.isSegmentMode) {
            this.updateSegmentDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true,
            });
            this.showError = false;
          } else {
            this.updateSlideDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true,
            });
          }
        }

        this.oldDuration = this.durationValue;
        this.closePopover();
      }

      this.toggleEditMode();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    updateTitleScreen() {
      this.updateSegmentTitle({ ...this.card, title: this.title });
    },
    updateSegment() {

      if(this.paramsClient.nb_screen_segment===1)
      this.updateFirstScreenSegmentTitle({ ...this.card, title: this.title });
      else
      this.updateSegmentTitle({ ...this.card, title: this.title });



      },
    updateTitleSlide() {
      if (parseInt(this.permissions.nb_screen_segment) === 1) {
        this.setCurrentSegmentTitle(this.title);
      } else {
        this.updateSlideTitle({ ...this.card, title: this.title });
      }
    },
    handleDelete(event) {
      const editor = grapesjsEMP.editors[0];
      this.$swal
        .fire({
          title: this.$t('modal.delete.title'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f44336',
          cancelButtonColor: '#2196F3',
          confirmButtonText: this.$t('modal.delete.btn_confirm'),
          cancelButtonText: this.$t('modal.delete.btn_cancel'),
          customClass: 'swal-delete',
        })
        .then(result => {
          if (result.value) {
            this.$swal.fire({
              title: 'Supprimé!',
              type: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            if (this.isSegmentMode) {
              this.deleteSlide();
            } else if (this.isSegmentCard) {
              this.deleteSegment();
            } else {
              this.deleteSlideFromSegment();
            }
            this.$root.$emit('updateCanvasContent');
            this.setNoAutoplayVideo(editor);
            var iconSave = document.querySelector('.icon-save');
            if (iconSave) {
              iconSave.classList.add('icon-selected');
            }
            this.$root.$emit('updateScrollInterval', { event: event, position: -1 });
          }
        });
    },
    deleteSlide() {
      const index = this.slideIndex(this.card);

      this.removeSlideByUid(this.card.uid);
      this.setCurrentSlide(this.allSlides[Math.max(index - 1, 0)]);
    },
    deleteSegment() {
      const index = this.segmentIndex(this.card);
      this.removeSegmentByUid(this.card.uid);
      this.setCurrentSegment(this.allSegments[Math.max(index - 1, 0)]);
      this.setCurrentSlide(
        this.allSegments[Math.max(index - 1, 0)].screens.filter(s => s.type !== 'startGeneric')[0],
      );
    },
    deleteSlideFromSegment() {
      const index = this.segmentIndex(this.segment);
      this.removeSlideFromSegmentByUid({ index, uid: this.card.uid });
      this.setCurrentSlide(this.segment.screens.filter(s => s.type !== 'startGeneric')[0]);
    },
    showSettingPanel() {
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);

      const brushEl = document.querySelector(
        '#gjs .gjs-pn-buttons .fa-paint-brush:not(.gjs-pn-active )',
      );
      const decorationTitleEl = document.querySelector(
        '#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title',
      );
      const durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

      if (brushEl) {
        brushEl.click();
      }
      if (decorationTitleEl) {
        decorationTitleEl.click();
        durationTitleEl.click();
      }
    },
  },
  i18n: {
    messages: {
      en,
      fr,
    },
  },
};
</script>

<style scoped lang="scss">
.panel-cards-actions-wrapper {
  ul {
    li {
      cursor: pointer;
      padding: 0 15px;
      &:hover {
        background: #f1f8fd;
      }
    }
  }
  .edit-panel {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0 0.5em;
    .form-group {
      margin-bottom: 8px !important;
      &.has-error {
        color: #dc3545;
        input.form-control {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
        }
        .text-error {
          position: absolute;
        }
      }
      label {
        margin-bottom: 0;
      }
    }
    .btn {
      padding: 0.2em;
      text-decoration: none !important;
    }
    .actions-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    button {
      padding: 0 !important;
      span {
        font-size: 1.2em !important;
        color: #9a9a9a !important;
        padding: 0;
        border: none !important;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CustomPanelCardActions.vue?19e1f9f3